module.exports = __webpack_public_path__ + "static/media/carpoolForeground.c040bf73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Carpool/carpoolForeground.svg
// module id = 929
// module chunks = 0